import { Component, output } from '@angular/core';

@Component({
  selector: 'app-retro-button',
  templateUrl: './retro-button.component.html',
  styleUrls: ['./retro-button.component.scss'],
})
export class RetroButtonComponent {
  readonly buttonClick = output<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
